module.exports = __webpack_public_path__ + "images/video-c8e73a9cf3d3aec786ade8f4c6185067.jpg";